import React from 'react';
import { Chip } from '@mui/material';

/** A ledger as a small chip; ledgers are their own names. Other props go to the MUI Chip. */
export const LedgerChip = ({ id, ...chipProps }) => <Chip size='small' label={id} {...chipProps} />;
